/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import * as _redux from "./redux";
import store, { persistor } from "./redux/store";
import App from "./app/App";
import './app/helpers/mixins'; // Add mixins lodash
import "./index.scss"; // Standard version
// import "./sass/style.react.rtl.css"; // RTL version
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
// Datepicker
import "react-datepicker/dist/react-datepicker.css";
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider
} from "./_metronic/layout";
import { MetronicI18nProvider } from "./_metronic/i18n";
import { AzureAD } from 'react-aad-msal';
import { authProvider } from '../src/app/provider/authProvider';
import { getStructureTreeBancoDeDados } from "./app/modules/Auth/_redux/authCrud";


import { EncryptStorage } from 'encrypt-storage';

export const encryptStorage = EncryptStorage('secret_key', {
  prefix: '@prefix'
});

export async function SetUserData(userAPIData) {
  if (userAPIData) {
      //if (getUser() == null) {
      const simulating = encryptStorage.getItem('SimulatingUser');      
      if (simulating !== true)
          encryptStorage.setItem('User', JSON.stringify(userAPIData));
      encryptStorage.setItem('UserReal', JSON.stringify(userAPIData));
      if(getUserFactoryId() == 0)
            encryptStorage.setItem('Factory', JSON.stringify(userAPIData['factory']));
      if (simulating !== true)
          encryptStorage.setItem('SystemRole', JSON.stringify(userAPIData['systemRole']));
      encryptStorage.setItem('SystemRoleReal', JSON.stringify(userAPIData['systemRole']));
      encryptStorage.setItem('CompanyRole', JSON.stringify(userAPIData['companyRole']));
    //}
      getStructureTree();
  }

}

export  function getUserId(){
  if(encryptStorage.getItem('User'))
        return encryptStorage.getItem('User').id
    else 
        return null
}

/**
 * 
 * @returns {AuthUser}
 */
export function getUser() {
  // let user = localStorage.getItem('persist:v713-demo1-auth')
  if (encryptStorage.getItem('User'))
    return encryptStorage.getItem('User')
  else
    return null
}

export function getUserReal() {
  // let user = localStorage.getItem('persist:v713-demo1-auth')
  if (encryptStorage.getItem('UserReal'))
    return encryptStorage.getItem('UserReal')
  else
    return null
}

/**
 * 
 * @returns {Number}
 */
export function getUserFactoryId() {
  // let user = localStorage.getItem('persist:v713-demo1-auth')
  if (encryptStorage.getItem('Factory'))
    return encryptStorage.getItem('Factory').id
  else
    return 0
}

export async function getStructureTree() {
  // let user = localStorage.getItem('persist:v713-demo1-auth')
    const factoryId = getUserFactoryId();
    const structureTree = await getStructureTreeBancoDeDados(factoryId);
    localStorage.setItem('StructureTree', JSON.stringify(structureTree));
    return structureTree  
}

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/* const mock = */ // _redux.mockAxios(axios);

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store);

ReactDOM.render(
  <AzureAD provider={authProvider} forceLogin={true}>
    <MetronicI18nProvider>
      <MetronicLayoutProvider>
        <MetronicSubheaderProvider>
          <MetronicSplashScreenProvider>
            <App store={store} persistor={persistor} basename={PUBLIC_URL} />
          </MetronicSplashScreenProvider>
        </MetronicSubheaderProvider>
      </MetronicLayoutProvider>
    </MetronicI18nProvider>
  </AzureAD>,
  document.getElementById("root")
);
